<template>
	<div :name="`name${data.qid}`" class="test_question box">
		<p
			class="title"
			:style="{
				fontSize: bandingstyle.appearancePhone.fontStemSize + 'px',
				color: bandingstyle.appearancePhone.fontStemColor,
				fontWeight: bandingstyle.appearancePhone.fontStemBold,
				fontStyle: bandingstyle.appearancePhone.fontStemItalic,
				textDecoration: bandingstyle.appearancePhone.fontStemUnderline
			}"
		>
			<span v-if="data.mustanswer" class="required"></span>
			<HtmlClickImgEnlarge :content="data.questionsName" />
		</p>

		<div class="input_box">
			<div>
				<!-- 正常显示 -->
				<!-- <template v-if="data.lineRankExchange == false"> -->
					<template v-if="data.fillBoxSlide == false">
						<div class="list-box" v-for="item2 in data.questionsSonList" :key="item2.SonId">
							<HtmlClickImgEnlarge class="list-title" :content="item2.questionsName" />
							<template v-if="data.questionsTypeId == '19' || data.questionsTypeId == '20'">
								<div class="list-item">
									<div class="option-item" v-for="option in item2.optionList" :key="option.oid">
										<el-radio-group v-if="data.questionsTypeId == '19'" @change="changeRadio" size="mini" v-model="item2.isSelected" class="list-radio">
											<el-radio-button
												:label="option.oid"
												:style="{
													fontSize: bandingstyle.appearancePhone.fontOptionSize + 'px',
													color: bandingstyle.appearancePhone.fontOptionColor,
													fontWeight: bandingstyle.appearancePhone.fontOptionBold,
													fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
													textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
												}"
											>
												<HtmlClickImgEnlarge :content="option.labelName" />
											</el-radio-button>
										</el-radio-group>
										<el-checkbox-group
											v-else-if="data.questionsTypeId == '20'"
											@change="changeRadio"
											size="mini"
											v-model="item2.isSelected"
											class="list-radio"
										>
											<el-checkbox-button
												:label="option.oid"
												:style="{
													fontSize: bandingstyle.appearancePhone.fontOptionSize + 'px',
													color: bandingstyle.appearancePhone.fontOptionColor,
													fontWeight: bandingstyle.appearancePhone.fontOptionBold,
													fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
													textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
												}"
											>
												<HtmlClickImgEnlarge :content="option.labelName" />
											</el-checkbox-button>
										</el-checkbox-group>
											<div class="keyboard-box">
												<el-input
													class="list-input"
													size="medium"
													v-if="option.haveInput"
													v-model="option.inputValue"
													@input="haveInputInput(option)"
													:class="{ input__err: option.validate }"
													@blur="changeRadio"
													:placeholder="$t('UserAnswer.InputContent')"
												></el-input>
												
												<i v-if="option.format == 7 && !isPc" @click.stop="keyboardShowClick(item2.SonId+option.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
												<IDNumberKeyboard :ref="item2.SonId+option.oid" :userAnswer="option.inputValue" @updata="(val) => option.inputValue = val"></IDNumberKeyboard>
											</div>
										</div>
								</div>
							</template>
							<template v-if="data.questionsTypeId == '21' || data.questionsTypeId == '22'">
								<div class="list-item">
									<div class="option-item2" v-for="option in item2.optionList" :key="option.oid">
										<template v-if="data.questionsTypeId == '21'">
											<p
												:style="{
													fontSize: bandingstyle.appearancePhone.fontOptionSize + 'px',
													color: bandingstyle.appearancePhone.fontOptionColor,
													fontWeight: bandingstyle.appearancePhone.fontOptionBold,
													fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
													textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
												}"
												class="option-item2-title"
											>
												<HtmlClickImgEnlarge :content="option.labelName" />
											</p>
											<div class="star-item">
												<div class="star" v-for="(n, rateIndex) in data.highestScore" :key="option.oid + '-' + rateIndex" @click="ratingScore(n, option)">
													<img v-if="rateIndex < option.ratingScore" :src="xinga" alt="" />
													<img v-if="rateIndex >= option.ratingScore" :src="xingb" alt="" />
												</div>
											</div>
										</template>
										<template v-else-if="data.questionsTypeId == '22'">
											<p
												:style="{
													fontSize: bandingstyle.appearancePhone.fontOptionSize + 'px',
													color: bandingstyle.appearancePhone.fontOptionColor,
													fontWeight: bandingstyle.appearancePhone.fontOptionBold,
													fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
													textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
												}"
												class="option-item2-title"
											>
												<HtmlClickImgEnlarge :content="option.labelName" />
											</p>
											<div class="star-item keyboard-box">
												<el-input
													:class="{ input__err: option.validate }"
													v-model="option.userAnswer"
													@blur="completionBlur"
													:placeholder="$t('UserAnswer.InputContent')"
												></el-input>
												<i v-if="option.format == 7 && !isPc" @click.stop="keyboardShowClick(item2.SonId+option.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
												<IDNumberKeyboard :ref="item2.SonId+option.oid" :userAnswer="option.userAnswer" @updata="(val) => option.userAnswer = val"></IDNumberKeyboard>
											</div>
										</template>
									</div>
								</div>
							</template>
							<template v-else-if="data.questionsTypeId == '39'">
								<div class="list-item">
									<!-- {{item2}} -->
									<div class="option-item2" v-for="option in item2.optionList" :key="option.oid">
										<p
											:style="{
												fontSize: bandingstyle.appearancePhone.fontOptionSize + 'px',
												color: bandingstyle.appearancePhone.fontOptionColor,
												fontWeight: bandingstyle.appearancePhone.fontOptionBold,
												fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
												textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
											}"
											class="option-item2-title"
										>
											<HtmlClickImgEnlarge :content="option.labelName" />
										</p>
										<div>
											<el-radio-group 
												v-if="option.type == '26'" 
												@change="completionBlur"
												size="medium" 
												v-model="item2.userAnswer"
												class="list-radio"
												:disabled="item2.disable"
											>
												<el-radio-button
													:label="option.oid"
													:style="{
														fontSize: bandingstyle.appearancePhone.fontOptionSize + 'px',
														color: bandingstyle.appearancePhone.fontOptionColor,
														fontWeight: bandingstyle.appearancePhone.fontOptionBold,
														fontStyle: bandingstyle.appearancePhone.fontOptionItalic,
														textDecoration: bandingstyle.appearancePhone.fontOptionUnderline
													}"
												>
													<HtmlClickImgEnlarge :content="option.labelName" />
												</el-radio-button>
											</el-radio-group>
											<el-select
												v-else-if="option.type == '10'"
												class="el-select"
												:popper-append-to-body="false"
												:placeholder="$t('UserAnswer.PleaseSelect')"
												:class="{ input__err: option.validate }"
												v-model="option.userAnswer"
												@change="completionBlur"
												:disabled="item2.disable"
											>
												<el-option v-for="info in option.options" :key="info.value" :label="info.label" :value="info.label">
													<HtmlClickImgEnlarge :content="info.label" />
												</el-option>
											</el-select>

											<el-upload
												v-else-if="option.type == '12'"
												class="upload-demo"
												ref="upload"
												:action="$config.service.uploadApi"
												:data="qn"
												:auto-upload="true"
												:limit="1"
												:before-upload="beforeFileUpload"
												:on-remove="(file, fileList) => handleRemove(file, fileList, option)"
												:on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 1, option)"
												:on-error="(err, file, fileList) => handleerror(err, file, fileList, option)"
												:on-exceed="(files, fileList) => handleexceed(files, fileList, option)"
												:file-list="option.fileList"
												:multiple="true"
												:disabled="item2.disable"
											>
												<el-button style="width: 100%;height:43px;background:#fff;color:#333" type="primary">
													<img src="@/assets/uploadfile.png" style="margin-right:10px" :alt="$t('UserAnswer.UploadFileImages')" />
													{{$t('UserAnswer.UploadFilesWithin10M')}}
												</el-button>
											</el-upload>
											<div v-else class="keyboard-box">

												<el-input
												type="textarea"
													v-if="option.type == '1'"
													:class="{ input__err: option.validate }"
													v-model="option.userAnswer"
													class="Rectinput"
													:rows="2"
													@blur="completionBlur"
												></el-input>
												<el-input
													v-else
													type="text"
													:class="{ input__err: option.validate }"
													v-model="option.userAnswer"
													class="Rectinput"
													@blur="completionBlur"
												></el-input>
												<i v-if="!isPc" @click.stop="keyboardShowClick(item2.SonId+option.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
												<IDNumberKeyboard :ref="item2.SonId+option.oid" :userAnswer="option.userAnswer" @updata="(val) => option.userAnswer = val"></IDNumberKeyboard>
											</div>
											<!-- </div> -->
										</div>
									</div>
								</div>
							</template>
						</div>
					</template>
					<template v-else>
						<div class="input_box">
							<div style="max-width: 1100px; overflow-x: auto;">
								<!-- 正常显示 -->
								<table style="margin-top:10px;">
									<tr>
										<td class="td_width"></td>
										<td class="td_width" v-for="(option, index2) in data.questionsSonList[0].optionList" :key="index2">
											<div style="width: 150px;"><HtmlClickImgEnlarge :content="option.labelName" /></div>
										</td>
									</tr>
									<tr v-for="(item2, index) in data.questionsSonList" :key="item2.SonId + index">
										<td class="td_width">
											<div style="width: 150px;"><HtmlClickImgEnlarge :content="item2.questionsName" /></div>
										</td>
										<td
											class="td_width"
											:class="{ 'padding-10': data.questionsTypeId == '21' || data.questionsTypeId == '22' ? true : false }"
											v-for="(option, index3) in item2.optionList"
											:key="index + '-' + index3"
										>
											<template v-if="data.questionsTypeId == '19' || data.questionsTypeId == '20'">
												<el-radio v-if="data.questionsTypeId == '19'" type="radio" :label="option.oid" v-model="item2.isSelected" @change="changeRadio">
													{{ empty }}
												</el-radio>
												<el-checkbox
													v-else-if="data.questionsTypeId == '20'"
													type="checkbox"
													v-model="item2.isSelected"
													:label="option.oid"
													@change="changeRadio"
												>
													{{ empty }}
												</el-checkbox>
												<input
													type="text"
													@input="haveInputInput(option)"
													:class="{ input__err: option.validate }"
													v-model="option.inputValue"
													v-if="option.haveInput"
													style="border: 1px solid #ccc;width: 60px;"
													@blur="changeRadio"
												/>
											</template>
											<template v-else-if="data.questionsTypeId == '21'">
												<ul class="ul_rate" :option="option.oid">
													<li v-for="(n, rateIndex) in data.highestScore" :key="option.oid + '-' + rateIndex" @click="ratingScore(n, option)">
														<img v-if="rateIndex < option.ratingScore" :src="xinga" alt="" />
														<img v-if="rateIndex >= option.ratingScore" :src="xingb" alt="" />
													</li>
												</ul>
											</template>
											<div class="keyboard-box" v-else-if="data.questionsTypeId == '22'">
												<input
													type="text"
													:class="{ input__err: option.validate }"
													v-model="option.userAnswer"
													class="Rectinput"
													@blur="completionBlur"
												/>
												<i v-if="option.format == 7 && !isPc" @click.stop="keyboardShowClick(item2.SonId+option.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
												<IDNumberKeyboard :ref="item2.SonId+option.oid" :userAnswer="option.userAnswer" @updata="(val) => option.userAnswer = val"></IDNumberKeyboard>
											</div>
											<template v-else-if="data.questionsTypeId == '39'">
												<el-select
													:popper-append-to-body="false"
													size="small"
													:placeholder="$t('UserAnswer.PleaseSelect')"
													v-if="option.type == '10'"
													:class="{ input__err: option.validate }"
													class="Rectselect"
													v-model="option.userAnswer"
													@change="completionBlur"
													:disabled="option.disable"
												>
													<el-option v-for="info in option.options" :key="info.value" :label="info.label" :value="info.label">
														<HtmlClickImgEnlarge :content="info.label" />
													</el-option>
												</el-select>

												<el-upload
													v-else-if="option.type == '12'"
													class="upload-demo"
													ref="upload"
													:action="$config.service.uploadApi"
													:data="qn"
													:auto-upload="true"
													:limit="1"
													:before-upload="beforeFileUpload"
													:on-remove="(file, fileList) => handleRemove(file, fileList, option)"
													:on-success="(response, file, fileList) => handleSuccess(response, file, fileList, 1, option)"
													:on-error="(err, file, fileList) => handleerror(err, file, fileList, option)"
													:on-exceed="(files, fileList) => handleexceed(files, fileList, option)"
													:file-list="option.fileList"
													:multiple="true"
													:disabled="option.disable"
												>
													<el-button style="width: 100%;height:43px;background:#fff;color:#333" type="primary">
														<img src="@/assets/uploadfile.png" style="margin-right:10px" :alt="$t('UserAnswer.UploadFileImages')" />
														{{$t('UserAnswer.UploadFilesWithin10M')}}
													</el-button>
												</el-upload>
												<div v-else class="keyboard-box">
													
													<el-input
													type="textarea"
														v-if="option.type == '1'"
														:class="{ input__err: option.validate }"
														v-model="option.userAnswer"
														class="Rectinput"
														:rows="2"
														@blur="completionBlur"
													></el-input>

													<input
														v-else
														type="text"
														:class="{ input__err: option.validate }"
														v-model="option.userAnswer"
														class="Rectinput"
														@blur="completionBlur"
													/>
													<i v-if="option.format == 7 && !isPc" @click.stop="keyboardShowClick(item2.SonId+option.oid)" class="keyboard wjpc-iconfont wjpc-icon-keyborad"></i>
													<IDNumberKeyboard :ref="item2.SonId+option.oid" :userAnswer="option.userAnswer" @updata="(val) => option.userAnswer = val"></IDNumberKeyboard>
												</div>
											</template>
										</td>
									</tr>
								</table>
							</div>
						</div>
					</template>
				<!-- </template> -->
			</div>
			<div v-show="data.validate" class="form-item__error">{{ data.validateMsg }}</div>
		</div>
	</div>
</template>

<script>
import HtmlClickImgEnlarge from '@/components/myComponents/htmlClickImgEnlarge.vue';
import IDNumberKeyboard from '@/components/IDNumberKeyboard/index.vue'
export default {
	components: {
		HtmlClickImgEnlarge,
		IDNumberKeyboard
	},
	name: 'MatrixTypePC',
	props: {
		data: {},
		bandingstyle: {}
	},
	data() {
		return {
			qn: {
				biz: 'upDataWj',
				data: {}
			},
			empty: '',
			xinga: require('@/assets/default-imgs/stars_1.png'), //亮星星
			xingb: require('@/assets/default-imgs/stars_2.png'), //暗星星
			isPc: true
		};
	},
	created() { 
		this.isPc = this.$functions.isPC()
		if (this.data.questionsTypeId == '22' || this.data.questionsTypeId == '39') {
			this.completionBlur();
		}
		// console.log(this.data)
	},
	methods: {
        keyboardShowClick(name) {
			console.log('name :>> ', name);
            const keyboardRef = this.$refs[name];
            if (keyboardRef && keyboardRef.length > 0) {
                keyboardRef[0].keyboardShowClick();
            } else if (keyboardRef) {
                keyboardRef.keyboardShowClick();
            } else {
                console.error('未找到对应的组件实例');
            }
        },
		handleSuccess(response, file, fileList, num, option) {
			console.log(option);
			console.log(this.data.userAnswer);
			option.userAnswer = [];
			this.data.userAnswer = [];
			let tempFileList = JSON.parse(JSON.stringify(fileList));
			console.log(tempFileList);
			tempFileList.forEach(info => {
				// console.log(info);
				if (info.status === 'success') {
					option.userAnswer.push(info.response.message);
					this.data.userAnswer.push(info.response.message);
				}
			});
			option.fileList = fileList;
			this.data.fileList = fileList;
			this.userAnswerChange();
			// console.log(this.data.fileList)
			console.log(this.data.userAnswer);
		},
		beforeFileUpload(file) {
			let size = file.size / 1024 / 1024 < 10; //这里做文件大小限制
			if (!size) {
				this.$message({
					message: this.$t('UserAnswer.TheFileSizeCannotExceed10MB'),
					type: 'warning'
				});
				return size;
			}
			this.qn.data = file;
		},
		//选择上传文件
		handleRemove(file, fileList, option) {
			let arr = [];
			option.userAnswer = [];
			this.data.userAnswer = [];
			if (fileList.length > 0) {
				fileList.forEach(info => {
					option.userAnswer.push(info.response.message);
					this.data.userAnswer.push(info.response.message);
					let y = info.response.message.split('upDataWj/')[1];
					arr.push({
						name: y
					});
				});
			}
			option.fileList = arr;
			this.data.fileList = arr;
			this.userAnswerChange();
		},
		handleexceed(files, fileList) {
			this.$message({
				message: this.$t('UserAnswer.MaximumNumberOfTimes'),
				type: 'warning'
			});
		},
		handleerror(err, file, fileList, item) {
			this.$message({
				message: this.$t('UserAnswer.FailedToUploadFile'),
				type: 'warning'
			});
		},
		haveInputInput(option) {
			if (option.isMaxNum && option.inputValue.length > option.maxNum) {
				option.inputValue = option.inputValue.substring(0, option.maxNum - 1);
			}
		},
		userAnswerChange() {
			this.$emit('userAnswerChange', this.data);
		},
		changeRadio(e) {
			console.log(e);
			this.data.userAnswerArr = [];
			this.data.questionsSonList.forEach((info, index) => {
				let valueObj = {
					SonId: info.SonId,
					value: ''
				};
				let arr = [];
				info.optionList.forEach(el => {
					// console.log(el)
					switch(this.data.questionsTypeId) {
						case '19':
							// 单选
							if (info.isSelected == el.oid) {
								if (el.inputValue) {
									valueObj.value = `${info.isSelected}:${el.inputValue}`;
								} else {
									valueObj.value = `${info.isSelected}`;
								}
							}
							// console.log(`valueObj.value` )
							// console.log(valueObj.value )
							break;
						case '20':
							// 多选
							if (el.isSelected) {
								if (el.inputValue) {
									arr.push(`${el.oid}:${el.inputValue}`);
								} else {
									arr.push(el.oid);
								}
							}
							valueObj.value = arr.join(',');
						break;
					}
				});
				if (info.SonId == valueObj.SonId) {
					this.data.userAnswerArr[index] = valueObj;
				}
			});
			console.log(this.data.userAnswerArr);
			this.userAnswerChange();
		},
		ratingScore(n, opt) {
			this.data.userAnswerArr = [];
			opt.ratingScore = n;
			this.data.questionsSonList.forEach((info, index) => {
				let valueObj = {
					SonId: info.SonId,
					optionValue: []
				};
				let arr = [];
				info.optionList.forEach(el => {
					arr.push({
						oid: el.oid,
						value: el.ratingScore
					});
					valueObj.optionValue = arr;
				});
				if (info.SonId == valueObj.SonId) {
					this.data.userAnswerArr[index] = valueObj;
				}
			});
			this.userAnswerChange();
		},
		completionBlur() {
			this.userAnswerChange();
			this.data.userAnswerArr = [];
			this.data.questionsSonList.forEach((info, index) => {
				let valueObj = {
					SonId: info.SonId,
				}
					let arr = [];
					info.optionList.forEach((el, j) => {
						if (info.type == '26') {
							if (info.userAnswer == el.oid) {
								arr.push({
									oid: el.oid,
									value: 1
								});
							} else {
								arr.push({
									oid: el.oid,
									value: ''
								});
							}
						} else {
							console.log('el.userAnswer :>> ', el.userAnswer);
							arr.push({
								oid: el.oid,
								value: el.userAnswer
							});
						}
					});
					valueObj.optionValue = arr;
				if (info.SonId == valueObj.SonId) {
					this.data.userAnswerArr[index] = valueObj;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.test_question {
	.option-box {
		display: flex;
		flex-direction: column;
		padding-left: 25px;
		.option + .option {
			margin-top: 10px;
		}
	}
}
.box {
	margin-top: 50px;
	.multiple {
		padding-left: 10px;
		.item-title {
			font-size: 14px;
			margin-bottom: 15px;
		}
	}
	.multiple + .multiple {
		margin-top: 20px;
	}
	.stem {
		padding-left: 10px;
		font-size: 14px;
		line-height: 30px;
	}
}
.required::before {
	content: '*';
	color: #f56c6c;
	margin-right: 4px;
}
.form-item__error {
	color: #f56c6c;
}

/deep/.input__err > .el-textarea__inner {
	border-color: #f56c6c;
}
.input_box {
	width: 50%;
	display: inline-block;
}
.input_box-border {
	display: inline-block;
}
table,
table td,
table th {
	border: 1px solid #ccc;
	border-collapse: collapse;
	text-align: center;
	padding: 10px;
	font-size: 14px;
}
.ul_rate {
	display: flex;
	justify-content: space-around;
}
.input_box {
	width: 100%;
}
.input__err {
	/deep/.el-input__inner{
		border-color: #f56c6c !important;
	}
}
.list-box + .list-box {
	margin-top: 10px;
}
.list-item {
	// display: flex;
	// flex-wrap: wrap;
}
.option-item {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	padding-right: 10px;
}
.option-item2 {
	width: 100%;
	margin-bottom: 10px;
	padding-left: 10px;
}
.list-title,
.option-item2-title {
	font-size: 14px;
	margin-bottom: 10px;
}
.star-item {
	display: flex;
}
.star {
	margin-right: 10px;
}
.list-input {
	width: 100%;
	display: inline-block;
	margin-left: 5px;
}
.list-radio + .list-radio {
	margin-left: 10px;
}
.list-radio {
	font-size: 16px;
}
/deep/.el-checkbox-button:last-child .el-checkbox-button__inner {
	border-radius: 4px !important;
}
/deep/.el-radio-button__inner,
/deep/.el-checkbox-button__inner {
	font-size: inherit;
}
.el-select {
	width: 100%;
}
.keyboard-box{
	position: relative;
	// /deep/.el-input__inner,
    // /deep/.el-textarea__inner{
	// 	padding-right: 40px;
	// }
}
.keyboard{
	position: absolute;    
	top: 8px;
	right: 8px;
	color: #f8a430;
	top: 50%; 
	transform: translateY(-50%);
	padding: 10px;
	z-index: 500;
	// width: 30px;
    // height: 100%;
}
</style>
